import keys from 'lodash/keys';
import trim from 'lodash/trim';
import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';

import { SentryLoggerService } from '../services/error-handler/sentry-logger.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorLoggerHttpInterceptor implements HttpInterceptor {
  constructor(private _logger: SentryLoggerService,
              @Inject('AppConfig') private _config: any) {
  }

  intercept(req: HttpRequest<any>,
            next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(catchError((error) => {
        if (error instanceof HttpErrorResponse && this._canBeLogged(req.url, error.status)) {
          this._logger.httpError(error);
        }

        return throwError(error);
      }));
  }

  private _canBeLogged(url: string, status: number) {
    const { sentryIgnoredApiErrors, sentryIgnoredApiErrorsStatuses } = this._config;
    let statuses = [];

    if (!sentryIgnoredApiErrors && !sentryIgnoredApiErrorsStatuses) {
      return true;
    }

    if (sentryIgnoredApiErrors) {
      url = trim(url, '/');

      const apiUrlKey = keys(sentryIgnoredApiErrors)
        .find(apiKey => {
          /** Example
           * apiKey = /store/cities/:refName/
           * url = http://api.stage.cakeiteasy.no/api/store/cities/oslo
           * Regular expresion should be
           * regular = /store/cities/[\w-]+$
           * It is necessary to understand if requested url matched or not with ignored api key
           * */
          const segments = trim(apiKey, '/')
            .split('/')
            .map(s => s.indexOf(':') === 0 ? '[\\w-]+' : s);

          const regular = new RegExp(segments.join('/') + '$');
          return (url.match(regular) || []).length;
        });

      const apiErrorsStatuses = apiUrlKey && sentryIgnoredApiErrors[apiUrlKey] ? sentryIgnoredApiErrors[apiUrlKey] : [];
      statuses.push(...apiErrorsStatuses);
    }

    if (sentryIgnoredApiErrorsStatuses && sentryIgnoredApiErrorsStatuses.length) {
      statuses.push(...sentryIgnoredApiErrorsStatuses);
    }

    // some(), not find(): find() returns the matched status itself, and a matched 0 is falsy
    return !statuses.some((s) => s == status);
  }
}
